import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	width: 50%;
	height: 100%;
	justify-content: space-between;
	flex-direction: row;
	align-items: flex-end;

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		align-items: center;
		width: 100%;
	}

	@media only screen and (max-width: 380px) {
		height: 40rem;
	}
`;

export const Content = styled.section`
	width: 100%;
	height: 100%;
	background: #23242f;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	font-family: "MetropolisRegular";

	@media only screen and (max-device-height: 615px) {
		overflow-y: scroll;
	}

	@media only screen and (max-width: 900px) {
		width: 100%;
		background: #13141b;
		position: relative;
		max-width: 23rem;
		justify-content: flex-start;
		margin: 3rem 0;
	}

	@media only screen and (max-width: 380px) {
		width: 85%;
	}

	form {
		width: 100%;
		max-width: 27rem;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;

		@media only screen and (max-width: 900px) {
			height: unset;
		}
	}
`;

export const Title = styled.label`
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	font-family: var(--font-family-metropolis-semi-bold);

	@media only screen and (max-width: 800px) {
		font-size: 16px;
	}

	&.hide-mobile {
		@media only screen and (max-width: 800px) {
			display: none;
		}
	}
`;

export const FormGroupInput = styled.div`
	position: relative;
	padding-top: 13px;
`;

export const PasswordEye = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	cursor: pointer;
	color: ${(props) => (props.error ? "#D30D48" : "#CACED4")};
	position: absolute;
	right: 16px;
	z-index: 1;
	top: 3.5rem;
`;

export const ContainerButton = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
